import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  addAddressUser,
  addressesList,
  deleteAddress,
  editAddress,
  setDefaultAddress,
} from "../../Redux";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Collapse from "react-bootstrap/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Footer from "../../Components/Footer";
import Switch from "@mui/material/Switch";
import Header from "../../Components/Header";
import GoBack from "../BackButton/GoBack";
import marker from "../../Assetes/Images/pin-red.png";
import { useHistory } from "react-router-dom";
import { SimplexMap } from "@simplex/map";
import useLocationEnabled from "../../hooks/useLocationEnabled";
import useCurrentLocale from "../../hooks/useLanguage";
import { useTranslation } from "react-i18next";
import GoogleMapComponent from "../../Components/GoogleMaps/googleMaps";
import ConfirmLocationMap from "../../Components/ManaraMaps";
import axios from "axios";
import { API_URL } from "../../Components/client-config";
import { MAPS_COUNTRY } from "../../lib";
import "../../Components/GoogleMaps/index.css";

function SaveAddress(props: any) {
  const history = useHistory();
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const addressData = useSelector((state: any) => state.customer.addressData);
  const [addAddress, setAddAddress] = useState(false);
  const [position, setPosition] = useState(null);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [house_name, setHouse_name] = useState("");
  const [block_number, setBlock_number] = useState("");
  const [searchString, setSearchString] = useState("");
  const [extraDetails, setExtraDetails] = useState("");
  const [place, setPlace] = useState("");
  const [value, setValue] = useState(0);
  const [saveAddress, setSaveAddress] = useState<any>(null);
  const [editAddress, setEditAddress] = useState(false);
  const [editClick, setEditFirstClick] = useState(false);
  const [coordinatesString, setCoordinatesString] = useState<string>("");
  const [isCoordinatesStringLoading, setIsCoordinatesStringLoading] =
    useState<boolean>(false);
  const [initialMapCenter, setInitalMapCenter] = useState<number[]>([]);
  const [selectedSearchAddress, setSelectedSearchAddress] =
    useState<string>("");
  const [placesSuggestion, setPlacesSuggestion] = useState([]);
  let token = localStorage.getItem("userToken");
  let userData: any = token ? jwt_decode(token) : null;
  const lang = useCurrentLocale();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!isLogged) {
      toast.error("Please login first to view saved addresses");
      history.push(`/${lang}/menu`);
    } else {
      props.addressesList();
    }
  }, []);
  useEffect(() => {
    if (addressData && addressData.length > 0) {
      let index = addressData.findIndex((obj: any, index: any) => {
        return obj.is_default == 1;
      });

      if (index !== -1) {
        const shiftedElement = addressData.splice(index, 1)[0];
        addressData.unshift(shiftedElement);
        setValue(value + 1);
      }
    }
  }, [addressData]);
  const handlePlace = (e: any) => {
    if (e.target.value == place) {
      setPlace("");
    } else {
      setPlace(e.target.value);
    }
  };
  const clearSearch = () => {
    let doc: any = document.getElementById("txtSearch")!;
    doc.value = "";
  };
  const handleAddressSubmit = () => {
    let arr = [];
    if (addressData && addressData.length > 0) {
      arr = addressData.filter((address: any) => {
        return address.place == place;
      });
    }
    const obj: any = {
      extra_details: extraDetails,
      full_address: selectedSearchAddress,
      street_name: house_name,
      street_number: block_number,
      place: place,
      lat: lat,
      lng: lng,
      customer_id: userData.customer.customer_id,
      is_default: 0,
    };
    if (arr && arr.length > 0) {
      if (place == "Home" || place == "Office") {
        if (arr.length >= 1) {
          toast.error(`${t("ONE_ADDRESS_ALLOWED")} ${place}`, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
          return;
        }
        props.addAddressUser(obj);
      } else if (place == "Other") {
        props.addAddressUser(obj);
      }
    } else {
      props.addAddressUser(obj);
    }
    setTimeout(() => {
      setAddAddress(false);
      setExtraDetails("");
      setHouse_name("");
      setBlock_number("");
      setPlace("");
      setLat("");
      setLng("");
      window.scroll(0, 0);
    }, 500);
  };
  const handleEditSubmit = () => {
    let arr = addressData.filter((address: any) => {
      return address.place == place;
    });
    let obj: any = {
      extra_details: extraDetails,
      street_name: house_name,
      street_number: block_number,
      place: place,
      lat: lat,
      lng: lng,
      customer_id: userData.customer.customer_id,
    };
    if (!editClick) {
      obj.full_address = selectedSearchAddress;
    }
    if (place == saveAddress.place) {
      props.editAddress(saveAddress.address_id, obj);
    } else {
      if (place == "Home" || place == "Office") {
        if (arr.length >= 1) {
          toast.error(`${t("ONE_ADDRESS_ALLOWED")} ${place}`, {
            position: toast.POSITION.TOP_RIGHT,
            hideProgressBar: true,
            autoClose: 3000,
          });
          return;
        }
        props.editAddress(saveAddress.address_id, obj);
      } else if (place == "Other") {
        props.editAddress(saveAddress.address_id, obj);
      }
    }

    setTimeout(() => {
      setEditAddress(false);
      setExtraDetails("");
      setHouse_name("");
      setBlock_number("");
      setPlace("");
      setLat("");
      setLng("");
      window.scroll(0, 0);
    }, 500);
  };

  const setDefaultAddress = async (address: any) => {
    props.setDefaultAddress(address.address_id);
  };
  const handleCloseButton = () => {
    if (addAddress) {
      setAddAddress(!addAddress);
    } else if (editAddress) {
      setEditAddress(!editAddress);
    }
    setPosition(null);
    setExtraDetails("");
    setHouse_name("");
    setBlock_number("");
    setPlace("");
    setLat("");
    setLng("");
  };
  const openAddAddressMap = () => {
    setAddAddress(true);
  };
  const handleMapData = (obj: any) => {
    // to Get the values from the map component and set in state
    setSelectedSearchAddress(obj.address);
    let data: any = {
      lat: obj.lat,
      lng: obj.lng,
    };
    setLat(obj.lat);
    setLng(obj.lng);
    setPosition(data);
  };
  const isAddAddressFormValid = () => {
    return (
      lat !== "" &&
      lng !== "" &&
      extraDetails !== "" &&
      place !== "" &&
      house_name !== "" &&
      block_number !== ""
    );
  };
  const handleEditAddress = async (data: any) => {
    setEditAddress(!editAddress);
    setSaveAddress(data);
    setPlace(data.place);
    setHouse_name(data.street_name);
    setBlock_number(data.street_number);
    setLat(data.lat);
    setLng(data.lng);
    setExtraDetails(data.extra_details);
    setSelectedSearchAddress(data.full_address);
    const positiondata: any = {
      lat: Number(data.lat),
      lng: Number(data.lng),
    };
    setInitalMapCenter([data.lng, data.lat]);
    await setPosition(positiondata);
  };
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (
        process.env.REACT_APP_GOOGLE_MAPS_ENABLE === "true" &&
        searchString.length > 3 &&
        searchString.length < 50
      ) {
        axios
          .get(
            `${API_URL}customer/autoComplete/${MAPS_COUNTRY}/${lang}/${searchString}`,
            {
              headers: {
                "x-api-key": process.env.REACT_APP_X_API_KEY,
              },
            }
          )
          .then((res: any) => {
            setPlacesSuggestion(res.data.data);
          })
          .catch((err: any) => {
            alert("something went wrong!!!");
          });
      } else {
        setPlacesSuggestion([]);
      }
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchString]);

  const onPlaceClick = (place: any) => {
    const geocoder = new google.maps.Geocoder();
    geocoder
      .geocode({ placeId: place.place_id })
      .then((response: any) => {
        if (response.results && response.results.length > 0) {
          const location = response.results[0].geometry.location;
          const obj = {
            lat: location.lat(),
            lng: location.lng(),
            address: place.description,
          };
          handleMapData(obj);
          setSelectedSearchAddress(place.description);
          setSearchString("");
          setPlacesSuggestion([]);
        } else {
          console.error("No results found");
        }
      })
      .catch((error: any) => {
        console.error("Geocode error:", error);
      });
  };

  const setCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position: any) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            {
              location: center,
            },
            (results: any, status) => {
              if (status === "OK" && results[0]) {
                setSelectedSearchAddress(results[0].formatted_address);
                const obj = {
                  lat: center.lat,
                  lng: center.lng,
                  address: results[0].formatted_address,
                };
                handleMapData(obj);
              } else {
                console.error("Geocoding failed:", status);
              }
            }
          );
        },
        (error) => {
          // console.error("Error checking geolocation permission:", error);
          toast.error(t("enableLocation"));
        },
        { maximumAge: 20000, timeout: 20000, enableHighAccuracy: false }
      );
    } else {
      toast.error(t("enableLocation"));
    }
  };

  const removeSearchString = () => {
    setSearchString("");
    setPlacesSuggestion([]);
  };
  const handleInputChange = (event: any) => {
    const queryString = event.target.value;
    setSearchString(queryString);
  };

  const label = { inputProps: { "aria-label": "switch demo" } };
  const isLocationEnabled: boolean = useLocationEnabled();
  useEffect(() => {
    if (!isLocationEnabled) {
      toast.error(t("ENABLE_BROWSER_LOCATION"));
    }
  }, [isLocationEnabled]);
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="container mt-120 profile-title">
        <span className="d-flex align-items-center gap-10 mb-3 web-backbtn">
          <GoBack />
          <div className="d-flex w-100 justify-content-between">
            <h2 className="mb-0">
              {!addAddress && !editAddress ? (
                `${t("ADDRESS")}`
              ) : editAddress && !addAddress ? (
                `${t("EDIT_ADDRESS")}`
              ) : (
                <>{t("ADDADDRESS")}</>
              )}
            </h2>
            {(addAddress || editAddress) && (
              <span
                className="save-address-close"
                onClick={() => handleCloseButton()}
              >
                <CloseIcon />
              </span>
            )}
          </div>
        </span>
        <div>
          {!addAddress &&
            !editAddress &&
            (addressData && addressData.length > 0 ? (
              addressData.map((obj: any, index: any) => {
                return (
                  <div className="save-address mb-2">
                    <div className="address-container">
                      <div className="address-items">
                        {obj.place == "Home" && (
                          <span>
                            <i className="ri-home-4-line"></i>
                          </span>
                        )}
                        {obj.place == "Office" && (
                          <span>
                            <i className="ri-building-2-fill"></i>
                          </span>
                        )}
                        {obj.place == "Other" && (
                          <span>
                            <i className="ri-community-fill"></i>
                          </span>
                        )}
                        <span>
                          {obj.place}&nbsp;
                          {obj.is_default == 1 ? "(Default)" : ""}
                        </span>
                      </div>
                      <div className="address-items">
                        <span
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            props.deleteAddress(addressData, obj.address_id)
                          }
                        >
                          <i className="ri-delete-bin-line"></i>
                        </span>
                        <span
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => handleEditAddress(obj)}
                        >
                          <EditIcon />
                        </span>
                        <div>
                          <Switch
                            className="address-switch"
                            {...label}
                            color="error"
                            onChange={() => {
                              setDefaultAddress(obj);
                            }}
                            checked={obj.is_default == 1}
                            disabled={obj.is_default == 1 ? true : false}
                          />
                        </div>
                      </div>
                    </div>
                    {/* <h5>PCSIR</h5> */}
                    <h6>
                      {obj.street_name ? `${obj.street_name}, ` : null}
                      {obj.street_number ? `${obj.street_number}, ` : null}
                      {obj.extra_details ? `${obj.extra_details}, ` : null}
                      {obj.full_address ? `${obj.full_address}` : null}
                    </h6>
                  </div>
                );
              })
            ) : (
              <h2 className="text-center mt-4">{t("NOADDRESSFOUND")}</h2>
            ))}
          {addAddress && (
            <div>
              <Collapse in={addAddress}>
                <div className="new-address">
                  <div className="mt-3">
                    {process.env.REACT_APP_GOOGLE_MAPS_ENABLE === "true" ? (
                      <>
                        <div className="input-container">
                          <div className="flex justify-between items-center gap-2 my-2">
                            <div className="d-flex justify-content-between relative w-full">
                              <div className="input-container">
                                <input
                                  className="custom-input text-base w-full"
                                  type="text"
                                  placeholder={t("ENTERFULLADDRESS")}
                                  value={searchString}
                                  onChange={handleInputChange}
                                />
                                <span className="focus-border"></span>
                              </div>
                              {searchString?.length > 0 && (
                                <button
                                  className="btn position-absolute top-0 end-0 p-0 mt-1 me-2"
                                  onClick={removeSearchString}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                >
                                  <i className="ri-close-fill text-primary-color-1 fs-4"></i>
                                </button>
                              )}
                            </div>
                            <button
                              className="btn text-white py-1 px-2 rounded"
                              onClick={setCurrentLocation}
                              style={{
                                backgroundColor: "#e4002b",
                                borderColor: "#e4002b",
                              }}
                            >
                              <i className="ri-focus-3-fill"></i>
                            </button>
                          </div>
                          <span className="focus-border"></span>
                          {searchString !== "" &&
                            placesSuggestion.length > 0 && (
                              <div className="address-suggestion">
                                <ul>
                                  {placesSuggestion.map((place: any) => {
                                    return (
                                      <>
                                        <li
                                          onClick={() => onPlaceClick(place)}
                                          className="suggestion-item"
                                        >
                                          <span className="upper-text">
                                            <strong>
                                              {
                                                place.structured_formatting
                                                  .main_text
                                              }
                                            </strong>
                                          </span>
                                          <span className="bottom-text">
                                            {
                                              place.structured_formatting
                                                .secondary_text
                                            }
                                          </span>
                                        </li>
                                      </>
                                    );
                                  })}
                                </ul>
                              </div>
                            )}
                        </div>
                        <GoogleMapComponent
                          setAddress={setSelectedSearchAddress}
                          onSetData={handleMapData}
                          mapCenter={position}
                          storeName={""}
                          setCurrentLocation={setCurrentLocation}
                        />
                      </>
                    ) : (
                      <fieldset className="d-fieldset">
                        <legend className="d-legend f-w-700">
                          {t("ENTERFULLADDRESS")}
                        </legend>
                        <ConfirmLocationMap
                          storesList={[]}
                          isAddAddressComp={true}
                          storeName={""}
                          setCoordinatesString={setCoordinatesString}
                          setIsCoordinatesStringLoading={
                            setIsCoordinatesStringLoading
                          }
                          onSetData={handleMapData}
                          setSearchString={setSearchString}
                          setSelectedSearchAddress={setSelectedSearchAddress}
                          initialMapCenter={initialMapCenter}
                          onPopupBtnClick={() => console.log("Popup clicked")}
                        />
                      </fieldset>
                    )}
                  </div>
                  <div className="row py-2 ">
                    <div className="col-1 d-flex align-items-center">
                      <img
                        width={25}
                        height={30}
                        src={marker}
                        id="address-marker"
                        alt=""
                      />
                    </div>
                    <div className="col-11 mt-2">
                      {/* <input value={props.searchString} disabled className="col-12 form-control" style={{ margin: "auto" }} /> */}
                      <h5
                        className="pin-location-text"
                        title={props.searchString}
                      >
                        {isLocationEnabled
                          ? selectedSearchAddress
                          : t("enableAndSearchLocation")}
                      </h5>
                    </div>
                    {/* here */}
                    <div className="col-md-6 mt-2">
                      <TextField
                        className="field-style"
                        id="filled-basic"
                        placeholder="House / Flat / Apartment / Office Number *"
                        variant="filled"
                        color="error"
                        onChange={(e) => {
                          var inputValue = e.target.value.trimStart();
                          e.target.value = inputValue;
                          setHouse_name(e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <TextField
                        className="field-style"
                        id="filled-basic"
                        placeholder="Block / Sector / Street / Building / Floor Name or Number *"
                        variant="filled"
                        color="error"
                        onChange={(e) => {
                          var inputValue = e.target.value.trimStart();
                          e.target.value = inputValue;
                          setBlock_number(e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        className="field-style"
                        id="filled-basic"
                        placeholder="Main Area / Town / Nearest Landmark *"
                        variant="filled"
                        color="error"
                        onChange={(e) => {
                          var inputValue = e.target.value.trimStart();
                          e.target.value = inputValue;
                          setExtraDetails(e.target.value);
                        }}
                      />
                    </div>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        className="justify-content-center mt-3"
                        value={place}
                        onClick={handlePlace}
                      >
                        <FormControlLabel
                          className="color-white"
                          value="Home"
                          control={<Radio color="error" />}
                          label="HOME"
                        />
                        <FormControlLabel
                          className="color-white"
                          value="Office"
                          control={<Radio color="error" />}
                          label="OFFICE"
                        />
                        <FormControlLabel
                          className="color-white"
                          value="Other"
                          control={<Radio color="error" />}
                          label="OTHER"
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </Collapse>
            </div>
          )}
          {editAddress && (
            <div>
              <Collapse in={editAddress}>
                <div className="new-address">
                  <div className="mt-3">
                   {process.env.REACT_APP_GOOGLE_MAPS_ENABLE === "true" ? (
                      <>
                        <div className="input-container">
                          <div className="flex justify-between items-center gap-2 my-2">
                            <div className="d-flex justify-content-between relative w-full">
                              <div className="input-container">
                                <input
                                  className="custom-input text-base w-full"
                                  type="text"
                                  placeholder={t("ENTERFULLADDRESS")}
                                  value={searchString}
                                  onChange={handleInputChange}
                                />
                                <span className="focus-border"></span>
                              </div>
                              {searchString?.length > 0 && (
                                <button
                                  className="btn position-absolute top-0 end-0 p-0 mt-1 me-2"
                                  onClick={removeSearchString}
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                >
                                  <i className="ri-close-fill text-primary-color-1 fs-4"></i>
                                </button>
                              )}
                            </div>
                            <button
                              className="btn text-white py-1 px-2 rounded"
                              onClick={setCurrentLocation}
                              style={{
                                backgroundColor: "#e4002b",
                                borderColor: "#e4002b",
                              }}
                            >
                              <i className="ri-focus-3-fill"></i>
                            </button>
                          </div>
                          <span className="focus-border"></span>
                          {searchString !== "" &&
                            placesSuggestion.length > 0 && (
                              <div className="address-suggestion">
                                <ul>
                                  {placesSuggestion.map((place: any) => {
                                    return (
                                      <>
                                        <li
                                          onClick={() => onPlaceClick(place)}
                                          className="suggestion-item"
                                        >
                                          <span className="upper-text">
                                            <strong>
                                              {
                                                place.structured_formatting
                                                  .main_text
                                              }
                                            </strong>
                                          </span>
                                          <span className="bottom-text">
                                            {
                                              place.structured_formatting
                                                .secondary_text
                                            }
                                          </span>
                                        </li>
                                      </>
                                    );
                                  })}
                                </ul>
                              </div>
                            )}
                        </div>
                        <GoogleMapComponent
                          setAddress={setSelectedSearchAddress}
                          onSetData={handleMapData}
                          mapCenter={position}
                          storeName={""}
                          setCurrentLocation={setCurrentLocation}
                        />
                      </>
                    ) : (
                      <fieldset className="d-fieldset">
                        <legend className="d-legend f-w-700">
                          {t("ENTERFULLADDRESS")}
                        </legend>
                        <ConfirmLocationMap
                          storesList={[]}
                          isAddAddressComp={true}
                          storeName={""}
                          setCoordinatesString={setCoordinatesString}
                          setIsCoordinatesStringLoading={
                            setIsCoordinatesStringLoading
                          }
                          onSetData={handleMapData}
                          setSearchString={setSearchString}
                          setSelectedSearchAddress={setSelectedSearchAddress}
                          initialMapCenter={initialMapCenter}
                          setEditFirstClick={setEditFirstClick}
                          onPopupBtnClick={() => console.log("Popup clicked")}
                        />
                      </fieldset>
                    )}
                  </div>
                  <div className="row my-2">
                    <div className="col-1 d-flex align-items-center">
                      <img
                        width={25}
                        height={30}
                        src={marker}
                        id="address-marker"
                        alt=""
                      />
                    </div>

                    <div className="col-11 mt-2">
                      {/* <input value={props.searchString} disabled className="col-12 form-control" style={{ margin: "auto" }} /> */}
                      <h5
                        className="pin-location-text"
                        title={props.searchString}
                      >
                        {isLocationEnabled
                          ? selectedSearchAddress
                          : t("enableAndSearchLocation")}
                      </h5>
                    </div>
                    <h4 className="mb-3 current-address">
                      {t("CURRENTSAVEDADDRESS")}
                    </h4>
                    <div className="col-12">
                      <input
                        value={saveAddress.full_address}
                        disabled
                        className="col-12 form-control custom-input  fulladdress"
                        style={{ margin: "auto" }}
                        autoComplete="off"
                        id="divSearch"
                      />
                    </div>
                    {/* here */}
                    <div className="col-md-6 mt-2">
                      <TextField
                        value={house_name}
                        className="field-style"
                        id="filled-basic"
                        placeholder="House / Flat / Apartment / Office Number *"
                        variant="filled"
                        color="error"
                        onChange={(e) => {
                          var inputValue = e.target.value.trimStart();
                          e.target.value = inputValue;
                          setHouse_name(e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-6 mt-2">
                      <TextField
                        value={block_number}
                        className="field-style"
                        id="filled-basic"
                        placeholder="Block / Sector / Street / Building / Floor Name or Number *"
                        variant="filled"
                        color="error"
                        onChange={(e) => {
                          var inputValue = e.target.value.trimStart();
                          e.target.value = inputValue;
                          setBlock_number(e.target.value);
                        }}
                      />
                    </div>
                    <div className="col-md-12 mt-3">
                      <TextField
                        value={extraDetails}
                        className="field-style"
                        id="filled-basic"
                        placeholder="Main Area / Town / Nearest Landmark *"
                        variant="filled"
                        color="error"
                        onChange={(e) => {
                          var inputValue = e.target.value.trimStart();
                          e.target.value = inputValue;
                          setExtraDetails(e.target.value);
                        }}
                      />
                    </div>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        className="justify-content-center mt-3"
                        value={place}
                        onClick={handlePlace}
                      >
                        <FormControlLabel
                          className="color-white"
                          value="Home"
                          control={<Radio color="error" />}
                          label={t("HOME")}
                        />
                        <FormControlLabel
                          className="color-white"
                          value="Office"
                          control={<Radio color="error" />}
                          label={t("OFFICE")}
                        />
                        <FormControlLabel
                          className="color-white"
                          value="Other"
                          control={<Radio color="error" />}
                          label={t("OTHER")}
                        />
                      </RadioGroup>
                    </FormControl>
                  </div>
                </div>
              </Collapse>
            </div>
          )}
          {!addAddress && !editAddress ? (
            <Button
              onClick={() => openAddAddressMap()}
              aria-expanded={addAddress}
              className="w-50 w-auto m-auto d-flex mt-2  px-2 white-space addrrss-btn"
              variant="contained"
              color="error"
            >
              <i className="ri-add-line delete-btn address-save" />
              {t("ADDADDRESS")}
            </Button>
          ) : addAddress ? (
            <Button
              disabled={!isAddAddressFormValid()}
              onClick={() => handleAddressSubmit()}
              className={`w-50 w-auto m-auto d-flex mt-2 color-white px-2 white-space' variant="contained ${
                !isAddAddressFormValid() ? "disable-btn" : "able-btn"
              }`}
              color="error"
            >
              <AddIcon /> {t("SAVEADDRESS")}
            </Button>
          ) : (
            <Button
              disabled={!isAddAddressFormValid()}
              onClick={() => handleEditSubmit()}
              className="w-50 w-auto m-auto d-flex mt-2 color-white px-2 white-space"
              variant="contained"
              color="error"
            >
              {t("UPDATEADDRESS")}
            </Button>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    addressesList: function () {
      dispatch(addressesList());
    },
    addAddressUser: (data: any) => {
      dispatch(addAddressUser(data));
    },
    deleteAddress: (data: any, id: number) => {
      dispatch(deleteAddress(data, id));
    },
    editAddress: (id: number, data: any) => {
      dispatch(editAddress(id, data));
    },
    setDefaultAddress: (address_id: any) => {
      dispatch(setDefaultAddress(address_id));
    },
  };
};

export default connect(null, mapDispatchToProps)(SaveAddress);
